export default Object.freeze({
  TITLE: '쇼핑몰 관리',
  BTN_NEW_SHOPPING_MALL_ADD: '신규 쇼핑몰등록',
	MALL_NO: '쇼핑몰번호',
  NAME_TITLE: '쇼핑몰명',
  PC_TITLE: 'PC웹',
  MOBILE_TITLE: '모바일웹',
  USED_TITLE: '사용여부',
  REGISTERADMIN_TITLE: '등록자',
  CREATEDDATETIME_TITLE: '등록일',
  GOTO_RIGHT_NOW: '바로가기',
  NOT_USE_STATE: '사용 안 함',
  SEE_APP_INFO: '앱 정보보기',
  THERE_IS_NO_DATA: '조회 결과가 없습니다.',
  SERVICE_IS_NO_DATA: '해당 서비스에 쇼핑몰이 존재하지않습니다.',
  EXPIRATION_DUE_DAYS: '남은 사용기간',
  DUE_DAYS: '{expirationDueDays}일 ',
  PAYMENT_DATE: '(결제 예정일 : {paymentDueDate})',
  EXTENSION: '연장',
  MESSAGE_PAYMENT_CONTENT:
    '쇼핑몰 등록 결제는 통합회원으로 전환된 대표운영자만 가능합니다. 통합회원 전환은 NHN커머스 홈페이지에서 가능합니다.',
  NOTICE_AFTER_MALL_REGISTER_INFO:
    '쇼핑몰 등록 후 쇼핑몰 수정 페이지에서 운영상 필요한 필수 정보들을 반드시 입력 하시길 바랍니다.',
  CREATE_SETTLEMENT_DATA: '정산 데이터 생성',
});
